
import * as React from "react";
const ReferIconSvg = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.63021 9.05841C7.54687 9.05008 7.44687 9.05008 7.35521 9.05841C5.37187 8.99175 3.79688 7.36675 3.79688 5.36675C3.79687 3.32508 5.44687 1.66675 7.49687 1.66675C9.53854 1.66675 11.1969 3.32508 11.1969 5.36675C11.1885 7.36675 9.61354 8.99175 7.63021 9.05841Z"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6747 3.3335C15.2914 3.3335 16.5914 4.64183 16.5914 6.25016C16.5914 7.82516 15.3414 9.1085 13.7831 9.16683C13.7164 9.1585 13.6414 9.1585 13.5664 9.16683"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.46367 12.1335C1.44701 13.4835 1.44701 15.6835 3.46367 17.0252C5.75534 18.5585 9.51367 18.5585 11.8053 17.0252C13.822 15.6752 13.822 13.4752 11.8053 12.1335C9.52201 10.6085 5.76367 10.6085 3.46367 12.1335Z"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2812 16.6667C15.8813 16.5417 16.4479 16.3001 16.9146 15.9417C18.2146 14.9667 18.2146 13.3584 16.9146 12.3834C16.4562 12.0334 15.8979 11.8001 15.3063 11.6667"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ReferIconSvg;
